(function () {
  'use strict';

  /* @ngdoc object
   * @name wbGdpr
   * @description
   *
   */
  angular
    .module('wbGdpr', [
      'ui.router'
    ]);
}());
